module.exports = __webpack_public_path__ + "static/img/aa_logo_white.71f9d83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aa_logo_white.png
// module id = BbMg
// module chunks = 7